<ion-header mode="ios">
  <ion-toolbar color="secondary">
    <ion-title class="text-grey-ultra-dark">{{ 'pages.fund-cash.purchase.transferManageModal.title' | translate }} </ion-title>

    <ion-buttons slot="end">
      <ion-button [attr.aria-label]="'pages.quotes.modal.cancel' | translate" (click)="cancel()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ui-current-cdc [project]="(project$ | async) ?? undefined"></ui-current-cdc>
</ion-header>

<ion-content class="ion-no-padding">
  <div class="request ion-padding ion-flex-column gap-4">
    <span class="ion-text-uppercase">{{ 'pages.fund-cash.purchase.transferManageModal.request.title' | translate }}</span>
    <span class="font-regular"
      >{{
        'pages.fund-cash.purchase.transferManageModal.request.description'
          | translate
            : {
                name: purchase.createdUser?.name,
                date: (purchase.createdDate | date: 'short')
              }
      }}
    </span>
  </div>
  <div class="article ion-padding ion-flex-column">
    <span class="ion-text-uppercase">{{ 'pages.fund-cash.purchase.transferManageModal.article' | translate }}</span>
    <h5>{{ purchase.article?.description }}</h5>
    <div class="notes">
      <h6>{{ 'pages.fund-cash.purchase.transferManageModal.notes' | translate }}:</h6>
      <span class="font-regular">{{ purchase.comment }}</span>
    </div>
  </div>
  <ui-approve-reject-toggle-buttons
    class="mt-10 ion-padding"
    [forceColour]="true"
    [approveText]="'pages.fund-cash.purchase.transferManageModal.accept' | translate"
    [rejectText]="'pages.fund-cash.purchase.transferManageModal.reject' | translate"
    (approvalResult)="onApprovalResult($event)"
  >
  </ui-approve-reject-toggle-buttons>
</ion-content>
